<div class="siteContainer" [ngClass]="{'on-menu': isOnMenuPage, 'on-home': isOnHomePage && !isMobile}" id="site-container">
  <header class="header">
    <app-navigation></app-navigation>
  </header>

  <section class="content" id="content">
    <router-outlet></router-outlet>
    <div class="siteContainer content-loading text-info-label-bold disable-select" *ngIf="isLoading">
      <img [src]="loadingLogo" draggable="false" *ngIf="loadingLogo" />
      <div>loading...</div>
    </div>
  </section>
</div>
